import { PrimaryCategoryKeys } from '@webapp/platform/organization-management/entities/enums/PrimaryCategoryKeys'

const primaryCategoryKey = 'primary-category'

export const primaryCategoryKeys = {
  all: [primaryCategoryKey],
  configList: [primaryCategoryKey, PrimaryCategoryKeys.CONFIG_LIST],
  configDetail: (id: number) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_DETAIL,
    id,
  ],
  secondaryCategories: (id: number) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_DETAIL,
    id,
    PrimaryCategoryKeys.SECONDARY_CATEGORIES,
  ],
  secondaryCategoryConfigDetail: (id: number) =>
    [primaryCategoryKey, 'secondary-category-config-detail', id] as const,
  configUsers: (id: number) => [
    primaryCategoryKey,
    PrimaryCategoryKeys.CONFIG_DETAIL,
    id,
    PrimaryCategoryKeys.CONFIG_USERS,
  ],
}
